import { GET_STREAMER_CARDS_REQUEST, GET_STREAMER_CARDS_RESPONSE } from './streamerCardsActions'

// Updates the state with streamer cards received from the server
const streamerCards = function (state = { streamers: [] }, action) {
  switch (action.type) {
    case GET_STREAMER_CARDS_RESPONSE:
      return {
        ...state,
        streamers: action.streamerCards
      }

    case GET_STREAMER_CARDS_REQUEST:
    // Do nothing right now, but in future we can set splash screen or some other indicator
      return state

    default:
      return state
  }
}

export default streamerCards
